import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";
import ErrorPage from "./error-page";
import Root from './components/root'
import HomePage from './components/HomePage';
import MessageOfPeace from './components/MessageOfPeace';
import History from './components/History';
import Documents from './components/Documents';
import OurAncestors from './components/OurAncestors';
import Contacts from './components/Contacts'
import News from './components/News'


const router = createBrowserRouter([
  {
    path: "/",
    element: <Root />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: "",
        element: <HomePage />,
      },
      {
        path: "message_of_peace",
        element: <MessageOfPeace />,
      },
      {
        path: "history",
        element: <History />,
      },
      {
        path: "documents",
        element: <Documents />,
      },
      {
        path: "our_ancestors",
        element: <OurAncestors />,
      },
      {
        path: "contacts",
        element: <Contacts />,
      },
      {
        path: "news",
        element: <News />,
      }
    ]
  }
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

reportWebVitals();
